import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from '@angular/core';
import { takeWhile } from "rxjs/operators";
import { Subject } from 'rxjs';

import {
    FvmsCommonService
} from "src/app/shared/service";
import {
    FilterDateTime
    ,FilterLeftPadd
} from "src/app/shared/filter";

@Component({
    selector: "ymd-selector"
    ,templateUrl: "./ymd.selector.component.html"
    ,styleUrls: ["./ymd.selector.component.scss"]
    ,providers: [FilterDateTime,FilterLeftPadd]
})
export class YmdSelectorComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    yy:string = "";
    mm:string = "";
    dd:string = "";
    @Output() callbackDate = new EventEmitter();

    constructor(  
        private fvmsCommonService: FvmsCommonService
        ,private filterDateTime:FilterDateTime
        ,private filterLeftPadd:FilterLeftPadd
    ) {
        
    }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {}

    @Input()
    set selectedDate(selectedDate:string) {
        this.yy = this.filterDateTime.transform(selectedDate,"yyyy");
        this.mm = this.filterDateTime.transform(selectedDate,"MM");
        this.dd = this.filterDateTime.transform(selectedDate,"dd");
    }

    changeYear(e){
        // console.log("changeYear",this.yy);
        this.callbackDate.emit(this.getYmd());
    }

    changeMonth(e){
        // console.log("changeMonth",this.mm);
        this.callbackDate.emit(this.getYmd());
    }

    changeDay(e){
        // console.log("changeDay",this.dd);
        this.callbackDate.emit(this.getYmd());
    }

    getYmd():string{
        let strYY = this.filterLeftPadd.transform(this.yy,4);
        let strMM = this.filterLeftPadd.transform(this.mm,2);
        let strDD = this.filterLeftPadd.transform(this.dd,2);
        return `${strYY}-${strMM}-${strDD}` || "";
    }
}